import React from 'react';

import { fieldModuleRegistry } from '@/forms/field-modules/registry';
import { type FormField } from '../typings';

type FormFieldMapperProps = {
  field: FormField;
  disabled?: boolean;
};

export const FormFieldMapper: React.FC<FormFieldMapperProps> = ({
  field,
  disabled,
}) => {
  const mod = fieldModuleRegistry.get(field.type);
  const Presenter = mod.Presenter;

  return <Presenter key={field.fieldId} field={field} disabled={disabled} />;
};
